Controller = require 'controller'
WarningBannerView = require 'views/header/warning-banner-view'
templates = require 'views/internal/templates'
_ = require 'underscore'
l = require 'lib/localize'
campaigns = require 'data/marketing-campaign-boards'
{ usesEnglish } = require '@trello/locale'

module.exports = class PublicBoardBannerView extends WarningBannerView
  className: ->
    trelloForTeams = if @model.id in campaigns.TRELLO_FOR_TEAMS then 'trello-for-teams' else ''
    "header-banner mod-warning #{trelloForTeams}"

  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @render

  getBannerText: ->
    text = {
      interactionText: l(['public interactions', @getPermissionsText()])
      ctaKey: 'sign-up-for-free'
    }

    if @model.id in campaigns.TRELLO_FOR_TEAMS
      text.interactionText = l(['trello for teams campaign interaction'])
      text.ctaKey = 'get-started'

    else if @model.id in campaigns.CAMPING
      text.interactionText = l(['adventure campaign interaction'])
      text.ctaKey = 'sign-up-its-free'

    # TODO gerard replace with a international version!
    else if usesEnglish()
      text.interactionText = "Visually collaborate with anyone, anywhere."

    text

  getPermissionsText: ->
    prefs = @model.get('prefs')
    couldVote = prefs.voting == 'public'
    couldComment = prefs.comments == 'public'

    if couldVote && couldComment
      'subscribe vote comment'
    else if couldVote
      'subscribe vote'
    else if couldComment
      'subscribe comment'
    'subscribe'

  render: ->
    urlEscaped = encodeURIComponent(Controller.getBoardUrl(@model))
    data = _.extend({
      signupUrl: "/signup?returnUrl=#{ urlEscaped }&source=public-board-banner"
    }, @getBannerText())

    @$el.html(
      templates.fill(
        'header_public_board',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/public-board-banner-view.coffee